import { FC } from "react";

import { ConflictErrorSeverity } from "@ryde/shared";

import { ConflictsNavStyled } from "./common.styled";

interface IConflictsNavProps {
  title: string;
  conflictNumber: number;
  severity?: ConflictErrorSeverity;
  accentColor?: string;
}

export const ConflictsNav: FC<IConflictsNavProps> = ({
  title,
  conflictNumber,
  severity = ConflictErrorSeverity.Critical,
  accentColor,
}) => {
  return (
    <ConflictsNavStyled $severity={severity} $accentColor={accentColor}>
      <strong className="ConflictsNav-Title">{title}</strong>
      <span className="ConflictsNav-ConflictNumbers">{conflictNumber}</span>
    </ConflictsNavStyled>
  );
};
